<template>
	<div class="landing-video-animation" :style="customStyles">
		<video autoplay muted playsinline :loop="loop" poster="">
			<source :src="url" :type="videoType" />
		</video>
	</div>
</template>

<script>
export default {
	name: 'LandingVideoAnimation',

	props: {
		url: {
			type: String,
			required: true,
		},

		loop: {
			type: Boolean,
			default: false,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {
		videoType() {
			const extension = this.url.split('.').pop()?.toLowerCase()

			switch (extension) {
				case 'webm':
					return 'video/webm'
				case 'mp4':
					return 'video/mp4'
				default:
					return 'video/mp4'
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-video-animation {
	line-height: 0;
	background: var(--Background-Base);
}

.landing-video-animation video {
	width: 100%;
	max-height: 100%;
	margin: 0 auto;
	display: block;
	object-fit: contain;
	background: var(--Background-Base);
	transform: translate3d(0, 0, 0);
}
</style>
